import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { GroupBooking } from '../../graphql/groups.datatypes';
import { updateCacheByType } from '../../graphql/GraphQlProvider';

export interface SubmitBookingToolInput {
    data: {
        booking_id?: number
        group_id: number
        start_date: string
        end_date: string
        billingPartiesData: Array<{
            id: string
            first_name: string
            last_name: string
            email: string
            address_line_1: string
            address_line_2: string
            city: string
            state: string
            zipcode: string
            country: string
            primary_phone: string
            primary_phone_code: string
            secondary_phone: string
            secondary_phone_code: string
            signature?: string
        }>
        roomsData: Array<{
            id: string
            wheelchair: boolean,
            hasInfants: boolean,
            notes: string
            guestsData: Array<{
                id: string
                first_name: string
                last_name: string
                dob: string
                tour_role: number
                primary_occupant: boolean
                roomGuestNumber: number
                billingPartyId: string
                optionValues: Array<{
                    id?: number
                    optionId: number
                    value: number
                    groupResourceOptionId: number
                }>
            }>
            optionValues: Array<{
                id?: number
                optionId: number
                value: number
                groupResourceOptionId: number
            }>
        }>
    }
}

interface SubmitBookingToolData {
    submitBookingTool: GroupBooking
}

export const SUBMIT_BOOKING_TOOL_MUTATION = gql`
    mutation submitBookingTool($data: SubmitBookingToolInput!) {
        submitBookingTool(data: $data) {
            id
            group_id

            billingParties {
                id
                group_booking_id
                credit_card_fee
                soft_cancelled
                disabled
                cost
                outstandingBalance
                overduePayments
                credit_card_fee_paid

                primaryPayingMember {
                    id
                    email
                }

                payingMembers {
                    id
                    primary_paying_member
                    first_name
                    last_name
                    email
                    address_line_1
                    address_line_2
                    city
                    state
                    zipcode
                    country
                    primary_phone
                    primary_phone_code
                    secondary_phone
                    secondary_phone_code
                    notes
                    billing_party_id
                }

                members {
                    id
                    billing_party_id
                    group_member_id
                    cost
                }
            }
        }
    }
`;

export const submitBookingTool = () => useMutation<SubmitBookingToolData, SubmitBookingToolInput>(
    SUBMIT_BOOKING_TOOL_MUTATION,
    {
        update: updateCacheByType('GroupBooking'),
    }
);

export default submitBookingTool;
